import { createReducer, on } from '@ngrx/store';
import { AvatarApiError } from './avatar.errors';
import {
  LoadAvatars,
  LoadAvatarsSuccess,
  SetLoadAvatarsError,
  RemoveAvatarsError,
} from './avatar.actions';
import { Avatar } from 'src/app/project-config/components/project-edit-form/models/avatar.model';

export interface AvatarState {
  avatars: Avatar[];
  error?: AvatarApiError;
}

export interface AvatarSchema {
  allOf: any;
}

export const initialAvatarState: AvatarState = {
  avatars: [],
  error: null,
};

export const avatarReducer = createReducer(
  initialAvatarState,
  on(LoadAvatars, (state) => ({
    ...state,
    error: null,
  })),
  on(LoadAvatarsSuccess, (state, { avatars }) => ({
    ...state,
    avatars,
  })),
  on(SetLoadAvatarsError, (state, { error }) => ({
    ...state,
    error,
  })),
  on(RemoveAvatarsError, (state) => ({
    ...state,
    error: null,
  })),
);
